import React from 'react';
import { StripeProvider } from 'react-stripe-elements';
import { Provider } from 'react-redux';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { store, history } from './redux/store';
import PublicRoutes from './router';
import '../src/style/styles.less';
import AppLocale from './languageProvider';
import config, { getCurrentLanguage } from './containers/LanguageSwitcher/config';

const currentAppLocale =
  AppLocale[getCurrentLanguage(config.defaultLanguage || 'english').locale];

const DashApp = () =>
  (
    <LocaleProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Provider store={store}>
          {process.env.NODE_ENV === 'production' // in the frontend this can be staging or production
            ?
            <StripeProvider apiKey={process.env.STRIPE_LIVE_PUBLISHABLE_KEY}>
              <PublicRoutes history={history} />
            </StripeProvider>

            :
            <StripeProvider apiKey={process.env.STRIPE_TEST_PUBLISHABLE_KEY}>
              <PublicRoutes history={history} />
            </StripeProvider>
          }
        </Provider>
      </IntlProvider>
    </LocaleProvider>
  );

export default DashApp;

export { AppLocale };

// frontend can't distingush between staging and prod --
// only backend can (due to publish functionality of Heroku)
const clearfrontkey = process.env.GOGLOBAL_API_KEY_CLIENT !== '' ? 'true' : 'false';
const stripe_env = process.env.NODE_ENV === 'production' ? 'prod' : 'test';

/* eslint-disable no-underscore-dangle */
console.warn(`>> NODE_ENV: ${process.env.NODE_ENV} (${process.env.NODE_ENV_HEROKU}) ` +
  ` clearfrontkey: ${clearfrontkey} stripe: ${stripe_env} ` +
  ` >> GIT REVISION: ${process.env.__GIT_REVISION__}`);
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/dashApp.js